{
    "TeamsAuth_UserIntro": "Bonjour {},",
    "TeamsAuth_UserIntro_2": "Akixi pour MS Teams demande l'accès à votre locataire Microsoft Entra.",
    "TeamsAuth_AdminConsent": "Consentement de l'administration de la subvention",
    "TeamsAuth_Authorise": "Autoriser",
    "TeamsAuth_ConsentedMessage": "Consentement administratif accordé, veuillez cliquer sur Autoriser pour continuer",
    "TeamsAuth_AuthorisedMessage": "Autorisation accordée",
    "TeamsAuth_Decline": "Déclin",
    "TeamsAuth_Error_Unknown": "Une erreur non reconnue s'est produite. Veuillez réessayer. Si le problème persiste, veuillez contacter votre administrateur système.",
    "NAME": "TeamsAuth"
}